/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".white-bg[_ngcontent-%COMP%]{background-color:#fff;border:1px solid rgba(179,179,179,.75)}"];
export { styles as styles };
